// @ts-strict-ignore
import { useRecommendedJobs } from 'hooks/useRecommendedJobs';
import queryString from 'query-string';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { LoadingIndicator } from 'components/LoadingIndicator';
import { TileCarousel } from 'components/TileCarousel';
import { MainStoreState } from 'modules/main/store';
import { JobFunction } from 'utils/constants';
import { listingSearchHomePath } from 'utils/searchHomePages';

type StandardCmsRecommendedJobsProps = {
  headline: string;
  layout: 'SLIM' | 'REGULAR';
  jobFunction: JobFunction | null | undefined;
  source: 'RECOMMENDED_JOBS_CHECKBOX' | 'RECOMMENDED_JOBS_BLOCK';
};

export function CmsStandardRecommendedJobs({
  headline,
  layout,
  jobFunction,
  source,
}: StandardCmsRecommendedJobsProps) {
  const searchLocation = useSelector<MainStoreState>(
    (state) => state.mainSearch.searchLocation
  ) as SearchLocation;

  const { data: recommendedJobs, isLoading } = useRecommendedJobs(
    searchLocation,
    {
      onlyWithLogo: layout === 'REGULAR',
      jobFunction,
    }
  );

  const additionalAnalyticsProps: Record<string, string> = {};

  if (jobFunction) additionalAnalyticsProps.job_function = jobFunction;

  const seeAllQueryString = useMemo(
    () =>
      queryString.stringify(
        {
          searchMode: true,
          q: '',
          functions: [jobFunction],
        },
        {
          skipNull: true,
        }
      ),
    [jobFunction]
  );

  if (isLoading) return <LoadingIndicator />;

  return (
    <TileCarousel
      headline={headline}
      results={recommendedJobs}
      seeAllText={
        /* TRANSLATORS: Link to job search */
        getText('See all jobs')
      }
      seeAllUrl={`${listingSearchHomePath('JOB')}?${seeAllQueryString}`}
      listingType="JOB"
      carouselLocation="CMS Page"
      layout={layout}
      source={source}
      additionalAnalyticsProps={additionalAnalyticsProps}
    />
  );
}
